import React from 'react';
import autoBind from 'react-autobind';
import Paper from 'material-ui/Paper';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import LinearProgress from 'material-ui/LinearProgress';
import { Redirect } from 'react-router-dom';
import Field from '../../components/Field';
import noty from '../../lib/noty';
import feathers from '../../feathers';
import { isStrongPassword } from '../../lib';

class AcceptInvitation extends React.Component {
  constructor(props) {
    super(props);
    this.acceptService = feathers.service('auth/accept-invite');
    this.state = {
      loaded: false,
      redirect: null,
      error: null,
      fetching: false,
      invitation: {},
      account: {},
      user: {
        email: '',
        first_name: '',
        last_name: '',
        password: ''
      },
      isNewUser: null
    };
    autoBind(this);
  }

  componentDidMount() {
    const { invitationId } = this.props.match.params;
    this.acceptService
      .get(invitationId)
      .then(({ invitation, account, isNewUser }) => {
        this.setState({
          loaded: true,
          invitation,
          account,
          user: { ...this.state.user, email: invitation.email },
          isNewUser
        });
      })
      .catch(err => {
        noty.errors(err);
        setTimeout(() => {
          this.setState({ redirect: '/login' });
        }, 3000);
      });
  }

  getPasswordHelp(password) {
    if (!password) {
      return '';
    } else {
      return isStrongPassword(password)
        ? 'Great!'
        : 'Please enter a stronger password.';
    }
  }

  handleChange({ name, value }) {
    this.setState({ user: { ...this.state.user, [name]: value } });
  }

  handleDecline(event) {
    event.preventDefault();
    this.setState({ fetching: true, error: false });
    const { invitationId } = this.props.match.params;
    this.acceptService
      .update(invitationId, { accept: false })
      .then(resp => {
        noty.success(resp.message);
        setTimeout(() => {
          this.setState({ redirect: '/login' });
        }, 3000);
      })
      .catch(err => {
        this.setState({
          error: err.message,
          fetching: false
        });
      });
  }

  async handleAccept(event) {
    event.preventDefault();
    const { user, isNewUser } = this.state;
    let payload = {
      accept: true,
      user,
      isNewUser
    };
    this.setState({ fetching: true, error: false });
    const { invitationId } = this.props.match.params;
    this.acceptService
      .update(invitationId, payload, { skipHooks: 'redirectUnAuthed' })
      .then(async ({ user }) => {
        await feathers._authenticate({
          strategy: 'local',
          email: user.email,
          password: payload.user.password
        });
        // TODO: add a /map/{facilityId}?accept-invitation=true (or isNewUser)
        // as the redirect URL and open the training modal when a user enters
        // the system via this flow

        // TODO: Look into the authLib and set the currentToken
        // as the token that just accepted the invite if not a new
        // user, if new user they just have the one.
        this.setState({
          redirect: `/`
        });
      })
      .catch(err => {
        this.setState({
          error: err.message,
          fetching: false
        });
      });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }
    const { account, user, isNewUser, loaded, fetching } = this.state;
    return (
      <div className="unauthed-page">
        <div className="container-fluid">
          <div className="row middle-md middle-sm middle-xs">
            <div className="col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-3 col-xs-12">
              {loaded && (
                <div>
                  <Paper className="unauthed-box">
                    <h2>Congratulations!</h2>
                    <p>You have been invited to join {account.name}.</p>
                    <form onSubmit={this.handleSubmit}>
                      {isNewUser && (
                        <React.Fragment>
                          <div className="row">
                            <div className="col-xs-6">
                              <Field
                                label="First Name"
                                name="first_name"
                                value={user.first_name}
                                onChange={this.handleChange}
                                disabled={fetching}
                              />
                            </div>
                            <div className="col-xs-6">
                              <Field
                                floatingLabelText="Last Name"
                                name="last_name"
                                value={user.last_name}
                                onChange={this.handleChange}
                                disabled={fetching}
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-xs-12">
                              <Field
                                disabled
                                label="Email"
                                name="email"
                                type="email"
                                value={user.email}
                                onChange={this.handleChange}
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-xs-12">
                              <Field
                                label="Password"
                                name="password"
                                value={user.password}
                                onChange={this.handleChange}
                                type="password"
                                disabled={fetching}
                                helpText={this.getPasswordHelp(user.password)}
                              />
                            </div>
                          </div>
                        </React.Fragment>
                      )}
                      {!isNewUser && (
                        <div className="row">
                          <div className="col-xs-12">
                            <Field
                              label="Password"
                              name="password"
                              value={user.password}
                              onChange={this.handleChange}
                              type="password"
                              disabled={fetching}
                            />
                          </div>
                        </div>
                      )}
                      <div className="row" style={{ marginTop: 16 }}>
                        <div className="col-xs">
                          <FlatButton
                            label="Decline"
                            primary
                            onClick={this.handleDecline}
                            disabled={fetching}
                          />
                        </div>
                        <div className="col-xs">
                          <RaisedButton
                            label="Accept Invitation!"
                            primary
                            style={{ float: 'right' }}
                            onClick={this.handleAccept}
                            disabled={fetching}
                            type="submit"
                          />
                        </div>
                      </div>
                    </form>
                  </Paper>
                  <div>
                    {this.state.fetching && (
                      <LinearProgress mode="indeterminate" />
                    )}
                    {this.state.error && (
                      <div className="unauthed-error">{this.state.error}</div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default AcceptInvitation;



// WEBPACK FOOTER //
// ./src/pages/AcceptInvitation/index.jsx